<template>
  <div class="flex flex-col gap-2 w-full">
    <div class="flex justify-between items-center">
      <span class="font-bold text-sm">Visualização</span>

      <button
        class="text-sm font-semibold text-[#3B82F6]"
        @click="updateDashboardChoice()"
        v-if="hasUnsavedChanges"
      >
        <span>Salvar</span>
      </button>
    </div>

    <div class="toggle-container">
      <div class="toggle-slider" :class="{ 'doctor': value === 'doctor' }"></div>

      <div class="toggle-buttons">
        <button @click="onViewChange('owner')" class="toggle-button" :class="{ 'active': value === 'owner' }">
          <v-icon :color="value === 'owner' ? 'white' : 'grey'" :size="20">
            mdi-domain
          </v-icon>

          <span class="font-semibold mt-1">
            Proprietário
          </span>
        </button>

        <button @click="onViewChange('doctor')" class="toggle-button" :class="{ 'active': value === 'doctor' }">
          <v-icon :color="value === 'doctor' ? 'white' : 'grey'" :size="20">
            mdi-account-check
          </v-icon>

          <span class="font-semibold mt-1">
            Profissional
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ViewToggle',

  props: {
    value: String,
  },

  computed: {
    ...mapGetters('subscription', {
      saasSubscription: 'GET_SAAS_SUBSCRIPTION',
    }),
    ...mapGetters('user', {
      preferences: 'GET_PREFERENCES',
      readOnly: 'GET_READONLY_INFO',
      userInfo: 'GET_USER_INFO',
    }),

    hasUnsavedChanges() {
      return this.userInfo?.preferences?.useDoctorDashboard
        ? this.value !== 'doctor'
        : this.value !== 'owner';
    },

    isSaas() {
      return !!this.readOnly?.saasId;
    },

    isSaasTeam() {
      return this.isSaas && this.readOnly?.saasRole !== 'user';
    },

    isSaasSubscriptionActive() {
      return this.saasSubscription && this.saasSubscription.status !== 'inactive';
    },
  },

  methods: {
    ...mapMutations('user', ['SET_CURRENT_VIEW']),

    onViewChange(value) {
      this.$emit('input', value);

      let ownerDashboard = 'owner-dashboard';

      if (this.isSaasTeam || this.isSaasSubscriptionActive) {
        ownerDashboard = 'owner-saas-dashboard';
      }

      this.SET_CURRENT_VIEW(value === 'doctor' ? 'doctor' : 'owner');

      this.$router.push({ name: value === 'doctor' ? 'doctor-dashboard' : ownerDashboard });
    },

    updateDashboardChoice() {
      this.$store.dispatch('user/updatePreferences', {
        payload: {
          useDoctorDashboard: this.value === 'doctor',
        },
        save: true,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.toggle-container {
  position: relative;
  background: #F3F4F6;
  border-radius: 12px;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
}

.toggle-slider {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 8px);
  background: linear-gradient(135deg, #3B82F6 0%, #10B981 100%);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: transform 300ms ease-in-out;
}

.toggle-slider.doctor {
  transform: translateX(calc(100% + 8px));
}

.toggle-buttons {
  position: relative;
  display: flex;
  z-index: 10;
}

.toggle-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: color 200ms ease;
  background: transparent;
  border: none;
  cursor: pointer;
}

.toggle-button.active {
  color: white;
}

.toggle-button:not(.active) {
  color: #6B7280;
}

.toggle-button:not(.active):hover {
  color: #374151;
}
</style>
